/**
 * mwApp.devices module <br>
 * Work with devices: show/add/edit/remove
 *
 * @namespace mwApp/devices
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/devices
 * @see mwApp/devices
 *
 * @ngdoc config
 * @name mwApp/devices.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /devices
     */
    .state('app.devices', {
      abstract: true,
      url: '/devices',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/devices.controller:DevicesCtrl}
     * @name /devices
     * @memberof mwApp/devices.config:ConfigRoutes
     */
    .state('app.devices.list', {
      url: '',
      templateUrl: 'components/devices/views/devices.html',
      controller: 'DevicesCtrl as vm',
      label: 'Devices',
      access: 'viewDevice'
    })

    /**
     * abstract state for /devices/:deviceId
     */
    .state('app.devices.device', {
      abstract: true,
      url: '/:deviceId',
      template: '<ui-view/>',
      resolve: {
        device: /* @ngInject */ function ($transition$, Device) {
          var { deviceId: id } = $transition$.params()
          return +id
            ? Device.load({ id })
            : new Device()
        }
      }
    })

    /**
     * controller {@link mwApp/devices.controller:AddDeviceCtrl}
     * @name /devices/:deviceId
     * @memberof mwApp/devices.config:ConfigRoutes
     */
    .state('app.devices.device.edit', {
      url: '',
      templateUrl: 'components/devices/views/addDevice.html',
      controller: 'AddDeviceCtrl as vm',
      label: '{{::deviceId | addOrEdit}} Device',
      access: ':deviceId (+) ! IF createDevice ELSE editDevice'
    })
}
